//主要用于系统类型的数据
export const appTypeList = [
  {
    value: 'all',
    name: '全部',
  },
  {
    value: 'android',
    name: '平板端',
  },
  {
    value: 'INTEGRATIONAPP',
    name: '手机端',
  },
];
